import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ActiveWindowService {
  private _activeWindowIdKey = 'bom.activeWindowId';
  private _windowId = Math.random().toString();

  /**
   * Allows execution of code in a single window, when code is run simultaneously between tabs
   * @param timespan Defines the window for when the code is detected as running simultaneously. Default = 1000
   */
  isMainWindow(timespan: number = 1000): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      window.localStorage.setItem(this._activeWindowIdKey, this._windowId);

      setTimeout(() => {
        const activeWindowId = window.localStorage.getItem(this._activeWindowIdKey);

        if (activeWindowId === this._windowId) {
          resolve(true);
        } else {
          resolve(false);
        }
      }, timespan);
    });
  }
}
